import { isPreparedFeed2Id } from '../lib/feedContext';
import { isLenta5Id } from '../lib/lenta5';

/**
 * Потоки в одной ленте /app. Человеку — номера, не происхождение.
 *
 * 0 — наши адаптеры, 1 — Кибер ГГ, 2 — BetBurger, 5 — publication v5.
 * Номер считается из id и поля `mir` кадра, не из подписи.
 */
export const TAPE_IDS = ['0', '1', '2', '5'] as const;

export type FeedTape = (typeof TAPE_IDS)[number];

export const TAPE_NAMES: Record<FeedTape, string> = {
  '0': 'лента 0',
  '1': 'лента 1',
  '2': 'лента 2',
  '5': 'лента 5',
};

export function isFeedTape(value: string): value is FeedTape {
  return value === '0' || value === '1' || value === '2' || value === '5';
}

/** Какой поток принёс строку. Пятёрка — по id, BetBurger — по id, Кибер ГГ — по `mir`. */
export function tapeOfFork(fork: { id?: string; mir?: unknown }): FeedTape {
  const id = typeof fork.id === 'string' ? fork.id : '';
  if (isLenta5Id(id)) return '5';
  if (isPreparedFeed2Id(id)) return '2';
  const raw = fork.mir;
  const mir = typeof raw === 'number' ? raw : Number(raw);
  if (mir === 1) return '1';
  return '0';
}

/** Пусто или все сразу — фильтра нет: человек работает со всеми потоками. */
export function canonTapes(values: readonly string[]): FeedTape[] {
  const out: FeedTape[] = [];
  const seen = new Set<FeedTape>();
  for (const raw of values) {
    if (!isFeedTape(raw) || seen.has(raw)) continue;
    seen.add(raw);
    out.push(raw);
  }
  if (out.length === TAPE_IDS.length) return [];
  return out;
}
